module.exports = __webpack_public_path__ + "img/DirectorForm.11914c48.jpg";